import { TableColumnDef } from '@melio/penny';
import { Collaborator } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { useMemo } from 'react';

import { RoleCell } from './components/cells/RoleCell';
import { UserCell } from './components/cells/UserCell';

export const useCollaboratorsTableColumns = () => {
  const { formatMessage } = useMelioIntl();

  return useMemo(() => {
    const userCell: TableColumnDef<Collaborator<'user'>> = {
      id: 'user',
      size: 'm',
      header: formatMessage('activities.settings.collaborators.table.headers.user'),
      cell: ({ row }) => <UserCell collaborator={row} />,
    };
    const roleCell: TableColumnDef<Collaborator<'user'>> = {
      id: 'role',
      size: 'm',
      header: formatMessage('activities.settings.collaborators.table.headers.role'),
      cell: ({ row }) => <RoleCell collaborator={row} />,
    };

    return [userCell, roleCell];
  }, [formatMessage]);
};
